/* THIS FILE IS AUTO-GENERATED BY `scripts/load-svg-icons.js`. DO NOT EDIT MANUALLY! */
import fill_alignedunder from "./fill/aligned-under.svg";
import fill_alignment from "./fill/alignment.svg";
import fill_alltime from "./fill/all-time.svg";
import fill_announcement from "./fill/announcement.svg";
import fill_arrowdown from "./fill/arrow-down.svg";
import fill_arrows1_refresh68 from "./fill/arrows-1_refresh-68.svg";
import fill_arrowsdownup from "./fill/arrows-down-up.svg";
import fill_attachment from "./fill/attachment.svg";
import fill_attention from "./fill/attention.svg";
import fill_audio from "./fill/audio.svg";
import fill_automation from "./fill/automation.svg";
import fill_badge from "./fill/badge.svg";
import fill_binocular from "./fill/binocular.svg";
import fill_blocked from "./fill/blocked.svg";
import fill_business_books from "./fill/business_books.svg";
import fill_business_bulb61 from "./fill/business_bulb-61.svg";
import fill_business_businesscontact86 from "./fill/business_business-contact-86.svg";
import fill_business_chartpie35 from "./fill/business_chart-pie-35.svg";
import fill_business_coins from "./fill/business_coins.svg";
import fill_business_factory from "./fill/business_factory.svg";
import fill_business_hammer from "./fill/business_hammer.svg";
import fill_business_hierarchy55 from "./fill/business_hierarchy-55.svg";
import fill_business_moneycoins from "./fill/business_money-coins.svg";
import fill_business_strategy from "./fill/business_strategy.svg";
import fill_business_wallet90 from "./fill/business_wallet-90.svg";
import fill_cascadingmetricalignment from "./fill/cascading-metric-alignment.svg";
import fill_cascadingmetric from "./fill/cascading-metric.svg";
import fill_checkin from "./fill/check-in.svg";
import fill_checkwhite from "./fill/check-white.svg";
import fill_clothes_shoewoman from "./fill/clothes_shoe-woman.svg";
import fill_clothes_slacks13 from "./fill/clothes_slacks-13.svg";
import fill_clothes_tiebow from "./fill/clothes_tie-bow.svg";
import fill_colorstarorangestroke from "./fill/color-star-orange-stroke.svg";
import fill_comments from "./fill/comments.svg";
import fill_contributingmetric from "./fill/contributing-metric.svg";
import fill_conversation from "./fill/conversation.svg";
import fill_design_bookbookmark from "./fill/design_book-bookmark.svg";
import fill_design_clone from "./fill/design_clone.svg";
import fill_design_codeeditor from "./fill/design_code-editor.svg";
import fill_design_code from "./fill/design_code.svg";
import fill_design_crop from "./fill/design_crop.svg";
import fill_design_design from "./fill/design_design.svg";
import fill_design_mouse10 from "./fill/design_mouse-10.svg";
import fill_design_paint38 from "./fill/design_paint-38.svg";
import fill_design_wand99 from "./fill/design_wand-99.svg";
import fill_design_webdesign from "./fill/design_web-design.svg";
import fill_design_windowcode from "./fill/design_window-code.svg";
import fill_design_windowdev from "./fill/design_window-dev.svg";
import fill_design_windowparagraph from "./fill/design_window-paragraph.svg";
import fill_dots from "./fill/dots.svg";
import fill_down from "./fill/down.svg";
import fill_education_atom from "./fill/education_atom.svg";
import fill_education_board51 from "./fill/education_board-51.svg";
import fill_education_hat from "./fill/education_hat.svg";
import fill_education_language from "./fill/education_language.svg";
import fill_ellipse from "./fill/ellipse.svg";
import fill_emoticons_fist from "./fill/emoticons_fist.svg";
import fill_emoticons_like from "./fill/emoticons_like.svg";
import fill_emoticons_monster from "./fill/emoticons_monster.svg";
import fill_emoticons_sunglasses48 from "./fill/emoticons_sunglasses-48.svg";
import fill_emoticons_virus from "./fill/emoticons_virus.svg";
import fill_employee from "./fill/employee.svg";
import fill_eye from "./fill/eye.svg";
import fill_favorite from "./fill/favorite.svg";
import fill_files_folder19 from "./fill/files_folder-19.svg";
import fill_food_coffeelong from "./fill/food_coffee-long.svg";
import fill_food_mug from "./fill/food_mug.svg";
import fill_furniture_bedside from "./fill/furniture_bed-side.svg";
import fill_goal from "./fill/goal.svg";
import fill_health_brain from "./fill/health_brain.svg";
import fill_health_weed from "./fill/health_weed.svg";
import fill_image from "./fill/image.svg";
import fill_inactivetask from "./fill/inactive-task.svg";
import fill_insight from "./fill/insight.svg";
import fill_insightboard from "./fill/insightboard.svg";
import fill_jirabug from "./fill/jira-bug.svg";
import fill_jiraepic from "./fill/jira-epic.svg";
import fill_jiraissue from "./fill/jira-issue.svg";
import fill_jirastory from "./fill/jira-story.svg";
import fill_jirasubtask from "./fill/jira-subtask.svg";
import fill_jiratask from "./fill/jira-task.svg";
import fill_jira from "./fill/jira.svg";
import fill_kpi from "./fill/kpi.svg";
import fill_links from "./fill/links.svg";
import fill_list from "./fill/list.svg";
import fill_loader_refresh from "./fill/loader_refresh.svg";
import fill_location_compass04 from "./fill/location_compass-04.svg";
import fill_location_positionmarker from "./fill/location_position-marker.svg";
import fill_marketplace from "./fill/marketplace.svg";
import fill_media1_image02 from "./fill/media-1_image-02.svg";
import fill_media1_sport from "./fill/media-1_sport.svg";
import fill_media1_touch from "./fill/media-1_touch.svg";
import fill_media1_video67 from "./fill/media-1_video-67.svg";
import fill_mention from "./fill/mention.svg";
import fill_metric from "./fill/metric.svg";
import fill_minus from "./fill/minus.svg";
import fill_modelandscape from "./fill/mode-landscape.svg";
import fill_modeportrait from "./fill/mode-portrait.svg";
import fill_more from "./fill/more.svg";
import fill_nopermissions from "./fill/no-permissions.svg";
import fill_noreflections from "./fill/no-reflections.svg";
import fill_nosearchresults from "./fill/no-search-results.svg";
import fill_objects_bear from "./fill/objects_bear.svg";
import fill_objects_leaf36 from "./fill/objects_leaf-36.svg";
import fill_objects_planet from "./fill/objects_planet.svg";
import fill_objects_spaceship from "./fill/objects_spaceship.svg";
import fill_objects_support17 from "./fill/objects_support-17.svg";
import fill_pdf from "./fill/pdf.svg";
import fill_plancommercial from "./fill/plan-commercial.svg";
import fill_planenterprise from "./fill/plan-enterprise.svg";
import fill_planessentials from "./fill/plan-essentials.svg";
import fill_planscale from "./fill/plan-scale.svg";
import fill_planupgrade from "./fill/plan-upgrade.svg";
import fill_plus from "./fill/plus.svg";
import fill_presentation from "./fill/presentation.svg";
import fill_private from "./fill/private.svg";
import fill_progress from "./fill/progress.svg";
import fill_public from "./fill/public.svg";
import fill_quantivecirclelogo from "./fill/quantive-circle-logo.svg";
import fill_related from "./fill/related.svg";
import fill_restrictedlicense from "./fill/restricted-license.svg";
import fill_search from "./fill/search.svg";
import fill_selectuser from "./fill/select-user.svg";
import fill_session from "./fill/session.svg";
import fill_shopping_box3d50 from "./fill/shopping_box-3d-50.svg";
import fill_shopping_creditcard from "./fill/shopping_credit-card.svg";
import fill_spreadsheet from "./fill/spreadsheet.svg";
import fill_standardlicense from "./fill/standard-license.svg";
import fill_success from "./fill/success.svg";
import fill_suggestions from "./fill/suggestions.svg";
import fill_taskgreen from "./fill/task-green.svg";
import fill_task from "./fill/task.svg";
import fill_team from "./fill/team.svg";
import fill_tech_computermonitor from "./fill/tech_computer-monitor.svg";
import fill_tech_mobilebutton from "./fill/tech_mobile-button.svg";
import fill_text from "./fill/text.svg";
import fill_thumbdown from "./fill/thumb-down.svg";
import fill_thumbup from "./fill/thumb-up.svg";
import fill_transportation_plane18 from "./fill/transportation_plane-18.svg";
import fill_trashbin from "./fill/trash-bin.svg";
import fill_travel_hut from "./fill/travel_hut.svg";
import fill_travel_world from "./fill/travel_world.svg";
import fill_ui1_analytics88 from "./fill/ui-1_analytics-88.svg";
import fill_ui1_boldremove from "./fill/ui-1_bold-remove.svg";
import fill_ui1_calendarcheck59 from "./fill/ui-1_calendar-check-59.svg";
import fill_ui1_checksimple from "./fill/ui-1_check-simple.svg";
import fill_ui1_dashboard30 from "./fill/ui-1_dashboard-30.svg";
import fill_ui1_database from "./fill/ui-1_database.svg";
import fill_ui1_home51 from "./fill/ui-1_home-51.svg";
import fill_ui1_settingsgear64 from "./fill/ui-1_settings-gear-64.svg";
import fill_ui1_simpleremove from "./fill/ui-1_simple-remove.svg";
import fill_ui2_alert from "./fill/ui-2_alert-.svg";
import fill_ui2_cloud25 from "./fill/ui-2_cloud-25.svg";
import fill_ui2_favourite28 from "./fill/ui-2_favourite-28.svg";
import fill_ui2_favourite31 from "./fill/ui-2_favourite-31.svg";
import fill_ui2_hourglass from "./fill/ui-2_hourglass.svg";
import fill_ui2_lab from "./fill/ui-2_lab.svg";
import fill_ui2_linkbroken70 from "./fill/ui-2_link-broken-70.svg";
import fill_up from "./fill/up.svg";
import fill_updatereminder from "./fill/update-reminder.svg";
import fill_update from "./fill/update.svg";
import fill_upgrade from "./fill/upgrade.svg";
import fill_upload from "./fill/upload.svg";
import fill_users_multiple11 from "./fill/users_multiple-11.svg";
import fill_users_multiple19 from "./fill/users_multiple-19.svg";
import fill_video from "./fill/video.svg";
import fill_whiteboard from "./fill/whiteboard.svg";
import fill_zip from "./fill/zip.svg";
import outline_addfrommarketplace from "./outline/add-from-marketplace.svg";
import outline_address from "./outline/address.svg";
import outline_alignbottom from "./outline/align-bottom.svg";
import outline_aligncenter from "./outline/align-center.svg";
import outline_alignleft from "./outline/align-left.svg";
import outline_alignmiddle from "./outline/align-middle.svg";
import outline_alignright from "./outline/align-right.svg";
import outline_aligntop from "./outline/align-top.svg";
import outline_alignmentview from "./outline/alignment-view.svg";
import outline_announcements from "./outline/announcements.svg";
import outline_apps from "./outline/apps.svg";
import outline_archive from "./outline/archive.svg";
import outline_arrowbig from "./outline/arrow-big.svg";
import outline_arrowdownsmall from "./outline/arrow-down-small.svg";
import outline_arrowrightsmall from "./outline/arrow-right-small.svg";
import outline_arrowupsmall from "./outline/arrow-up-small.svg";
import outline_arrows1_refresh68 from "./outline/arrows-1_refresh-68.svg";
import outline_arrows1_tailleft from "./outline/arrows-1_tail-left.svg";
import outline_arrows1_tailright from "./outline/arrows-1_tail-right.svg";
import outline_arrowsin from "./outline/arrows-in.svg";
import outline_arrowsout from "./outline/arrows-out.svg";
import outline_artificialintelligenceanimated from "./outline/artificial-intelligence-animated.svg";
import outline_artificialintelligence from "./outline/artificial-intelligence.svg";
import outline_ask from "./outline/ask.svg";
import outline_attachment from "./outline/attachment.svg";
import outline_attention from "./outline/attention.svg";
import outline_automation from "./outline/automation.svg";
import outline_award from "./outline/award.svg";
import outline_back from "./outline/back.svg";
import outline_bad from "./outline/bad.svg";
import outline_badgeaibetav2 from "./outline/badge-ai-beta-v2.svg";
import outline_billinghistory from "./outline/billing-history.svg";
import outline_binocular from "./outline/binocular.svg";
import outline_blocked from "./outline/blocked.svg";
import outline_book from "./outline/book.svg";
import outline_branding from "./outline/branding.svg";
import outline_business_award48 from "./outline/business_award-48.svg";
import outline_business_books from "./outline/business_books.svg";
import outline_business_bulb61 from "./outline/business_bulb-61.svg";
import outline_business_businesscontact86 from "./outline/business_business-contact-86.svg";
import outline_business_businesscontact89 from "./outline/business_business-contact-89.svg";
import outline_business_businessman03 from "./outline/business_businessman-03.svg";
import outline_business_chartpie35 from "./outline/business_chart-pie-35.svg";
import outline_business_coins from "./outline/business_coins.svg";
import outline_business_factory from "./outline/business_factory.svg";
import outline_business_hammer from "./outline/business_hammer.svg";
import outline_business_hierarchy55 from "./outline/business_hierarchy-55.svg";
import outline_business_moneycoins from "./outline/business_money-coins.svg";
import outline_business_strategy from "./outline/business_strategy.svg";
import outline_business_wallet90 from "./outline/business_wallet-90.svg";
import outline_calendar from "./outline/calendar.svg";
import outline_casttv from "./outline/cast-tv.svg";
import outline_caution from "./outline/caution.svg";
import outline_chart from "./outline/chart.svg";
import outline_chat from "./outline/chat.svg";
import outline_checkinnotifications from "./outline/check-in-notifications.svg";
import outline_checkin from "./outline/check-in.svg";
import outline_checksmall from "./outline/check-small.svg";
import outline_check from "./outline/check.svg";
import outline_chevrondoubleleftbig from "./outline/chevron-double-left-big.svg";
import outline_chevrondoublerightbig from "./outline/chevron-double-right-big.svg";
import outline_chevrondownbig from "./outline/chevron-down-big.svg";
import outline_chevrondownsmall from "./outline/chevron-down-small.svg";
import outline_chevronleftbig from "./outline/chevron-left-big.svg";
import outline_chevronleftdouble from "./outline/chevron-left-double.svg";
import outline_chevronleftsmall from "./outline/chevron-left-small.svg";
import outline_chevronrightbig from "./outline/chevron-right-big.svg";
import outline_chevronrightdoublebig from "./outline/chevron-right-double-big.svg";
import outline_chevronrightdouble from "./outline/chevron-right-double.svg";
import outline_chevronrightsmall from "./outline/chevron-right-small.svg";
import outline_chevronupbig from "./outline/chevron-up-big.svg";
import outline_chevronupsmall from "./outline/chevron-up-small.svg";
import outline_circle1 from "./outline/circle-1.svg";
import outline_circle from "./outline/circle.svg";
import outline_clipboard from "./outline/clipboard.svg";
import outline_clock from "./outline/clock.svg";
import outline_closebig from "./outline/close-big.svg";
import outline_closemedium from "./outline/close-medium.svg";
import outline_closemenu from "./outline/close-menu.svg";
import outline_clothes_shoewoman from "./outline/clothes_shoe-woman.svg";
import outline_clothes_slacks13 from "./outline/clothes_slacks-13.svg";
import outline_clothes_tiebow from "./outline/clothes_tie-bow.svg";
import outline_clothes_vestsport from "./outline/clothes_vest-sport.svg";
import outline_collapsenav from "./outline/collapse-nav.svg";
import outline_comments from "./outline/comments.svg";
import outline_consulting from "./outline/consulting.svg";
import outline_createnew from "./outline/create-new.svg";
import outline_creditcard from "./outline/credit-card.svg";
import outline_customfield from "./outline/custom-field.svg";
import outline_design_bookbookmark from "./outline/design_book-bookmark.svg";
import outline_design_clone from "./outline/design_clone.svg";
import outline_design_codeeditor from "./outline/design_code-editor.svg";
import outline_design_code from "./outline/design_code.svg";
import outline_design_crop from "./outline/design_crop.svg";
import outline_design_design from "./outline/design_design.svg";
import outline_design_mouse10 from "./outline/design_mouse-10.svg";
import outline_design_paint38 from "./outline/design_paint-38.svg";
import outline_design_wand99 from "./outline/design_wand-99.svg";
import outline_design_webdesign from "./outline/design_web-design.svg";
import outline_design_windowcode from "./outline/design_window-code.svg";
import outline_design_windowdev from "./outline/design_window-dev.svg";
import outline_design_windowparagraph from "./outline/design_window-paragraph.svg";
import outline_dislike from "./outline/dislike.svg";
import outline_done from "./outline/done.svg";
import outline_down from "./outline/down.svg";
import outline_download from "./outline/download.svg";
import outline_dragdrop from "./outline/drag-drop.svg";
import outline_dragicon from "./outline/drag-icon.svg";
import outline_edit from "./outline/edit.svg";
import outline_education_atom from "./outline/education_atom.svg";
import outline_education_board51 from "./outline/education_board-51.svg";
import outline_education_hat from "./outline/education_hat.svg";
import outline_education_language from "./outline/education_language.svg";
import outline_email from "./outline/email.svg";
import outline_emoticons_angry44 from "./outline/emoticons_angry-44.svg";
import outline_emoticons_cake from "./outline/emoticons_cake.svg";
import outline_emoticons_fist from "./outline/emoticons_fist.svg";
import outline_emoticons_like from "./outline/emoticons_like.svg";
import outline_emoticons_monster from "./outline/emoticons_monster.svg";
import outline_emoticons_nerd22 from "./outline/emoticons_nerd-22.svg";
import outline_emoticons_sunglasses48 from "./outline/emoticons_sunglasses-48.svg";
import outline_emoticons_virus from "./outline/emoticons_virus.svg";
import outline_exclamationmark from "./outline/exclamation-mark.svg";
import outline_expand from "./outline/expand.svg";
import outline_exportexcel from "./outline/export-excel.svg";
import outline_export from "./outline/export.svg";
import outline_externallink from "./outline/external-link.svg";
import outline_failed from "./outline/failed.svg";
import outline_favorite from "./outline/favorite.svg";
import outline_files_folder19 from "./outline/files_folder-19.svg";
import outline_filterview from "./outline/filter-view.svg";
import outline_filter from "./outline/filter.svg";
import outline_fittoscreen from "./outline/fit-to-screen.svg";
import outline_food_broccoli from "./outline/food_broccoli.svg";
import outline_food_chefhat from "./outline/food_chef-hat.svg";
import outline_food_chili from "./outline/food_chili.svg";
import outline_food_coffeelong from "./outline/food_coffee-long.svg";
import outline_food_crab from "./outline/food_crab.svg";
import outline_food_moka from "./outline/food_moka.svg";
import outline_food_muffin from "./outline/food_muffin.svg";
import outline_food_mug from "./outline/food_mug.svg";
import outline_fullsize from "./outline/full-size.svg";
import outline_furniture_bedside from "./outline/furniture_bed-side.svg";
import outline_gif from "./outline/gif.svg";
import outline_good from "./outline/good.svg";
import outline_gridview from "./outline/grid-view.svg";
import outline_halfsize from "./outline/half-size.svg";
import outline_hand from "./outline/hand.svg";
import outline_health_brain from "./outline/health_brain.svg";
import outline_health_weed from "./outline/health_weed.svg";
import outline_help from "./outline/help.svg";
import outline_hidden from "./outline/hidden.svg";
import outline_home from "./outline/home.svg";
import outline_idea from "./outline/idea.svg";
import outline_image from "./outline/image.svg";
import outline_infobig from "./outline/info-big.svg";
import outline_info from "./outline/info.svg";
import outline_inline from "./outline/inline.svg";
import outline_insightboard from "./outline/insightboard.svg";
import outline_insights from "./outline/insights.svg";
import outline_install from "./outline/install.svg";
import outline_integrations from "./outline/integrations.svg";
import outline_jira from "./outline/jira.svg";
import outline_kanban from "./outline/kanban.svg";
import outline_key from "./outline/key.svg";
import outline_kpi from "./outline/kpi.svg";
import outline_kr from "./outline/kr.svg";
import outline_lessisbetter from "./outline/less-is-better.svg";
import outline_license from "./outline/license.svg";
import outline_like from "./outline/like.svg";
import outline_link from "./outline/link.svg";
import outline_listbullet from "./outline/list-bullet.svg";
import outline_listnumbers from "./outline/list-numbers.svg";
import outline_listview from "./outline/list-view.svg";
import outline_livedemo from "./outline/live-demo.svg";
import outline_loadingcircular from "./outline/loading-circular.svg";
import outline_location_compass04 from "./outline/location_compass-04.svg";
import outline_location_explore from "./outline/location_explore.svg";
import outline_location_flagdiagonal33 from "./outline/location_flag-diagonal-33.svg";
import outline_location_positionmarker from "./outline/location_position-marker.svg";
import outline_logo from "./outline/logo.svg";
import outline_makecopy from "./outline/make-copy.svg";
import outline_manage from "./outline/manage.svg";
import outline_map from "./outline/map.svg";
import outline_media1_audio92 from "./outline/media-1_audio-92.svg";
import outline_media1_flash24 from "./outline/media-1_flash-24.svg";
import outline_media1_image02 from "./outline/media-1_image-02.svg";
import outline_media1_lens31 from "./outline/media-1_lens-31.svg";
import outline_media1_sport from "./outline/media-1_sport.svg";
import outline_media1_touch from "./outline/media-1_touch.svg";
import outline_media1_video67 from "./outline/media-1_video-67.svg";
import outline_media2_guitar from "./outline/media-2_guitar.svg";
import outline_mentions from "./outline/mentions.svg";
import outline_menuhorizontal from "./outline/menu-horizontal.svg";
import outline_menuvertical from "./outline/menu-vertical.svg";
import outline_minus from "./outline/minus.svg";
import outline_moreisbetter from "./outline/more-is-better.svg";
import outline_moveto from "./outline/move-to.svg";
import outline_move from "./outline/move.svg";
import outline_multiselect from "./outline/multiselect.svg";
import outline_negativedelete from "./outline/negative-delete.svg";
import outline_neutralwarn from "./outline/neutral-warn.svg";
import outline_neutral from "./outline/neutral.svg";
import outline_newlist from "./outline/new-list.svg";
import outline_newokr from "./outline/new-okr.svg";
import outline_next from "./outline/next.svg";
import outline_nocheckins from "./outline/no-checkins.svg";
import outline_notrestricted from "./outline/not-restricted.svg";
import outline_note from "./outline/note.svg";
import outline_notificationsoff from "./outline/notifications-off.svg";
import outline_notifications from "./outline/notifications.svg";
import outline_objective from "./outline/objective.svg";
import outline_objects_alien29 from "./outline/objects_alien-29.svg";
import outline_objects_alien33 from "./outline/objects_alien-33.svg";
import outline_objects_baby from "./outline/objects_baby.svg";
import outline_objects_bear from "./outline/objects_bear.svg";
import outline_objects_binocular from "./outline/objects_binocular.svg";
import outline_objects_diamond from "./outline/objects_diamond.svg";
import outline_objects_leaf36 from "./outline/objects_leaf-36.svg";
import outline_objects_leaf38 from "./outline/objects_leaf-38.svg";
import outline_objects_planet from "./outline/objects_planet.svg";
import outline_objects_spaceship from "./outline/objects_spaceship.svg";
import outline_objects_support17 from "./outline/objects_support-17.svg";
import outline_openmenu from "./outline/open-menu.svg";
import outline_organization from "./outline/organization.svg";
import outline_parallelogram from "./outline/parallelogram.svg";
import outline_parentchildview from "./outline/parent-child-view.svg";
import outline_parentview from "./outline/parent-view.svg";
import outline_pause from "./outline/pause.svg";
import outline_pdf from "./outline/pdf.svg";
import outline_performance from "./outline/performance.svg";
import outline_pie from "./outline/pie.svg";
import outline_pin from "./outline/pin.svg";
import outline_platformintelligencedefault from "./outline/platform-intelligence-default.svg";
import outline_play from "./outline/play.svg";
import outline_pluscircle from "./outline/plus-circle.svg";
import outline_plus from "./outline/plus.svg";
import outline_pointer from "./outline/pointer.svg";
import outline_process from "./outline/process.svg";
import outline_public from "./outline/public.svg";
import outline_quantivepluscaution from "./outline/quantive-plus-caution.svg";
import outline_reaction from "./outline/reaction.svg";
import outline_recenter from "./outline/recenter.svg";
import outline_rectangle from "./outline/rectangle.svg";
import outline_refresh from "./outline/refresh.svg";
import outline_rename from "./outline/rename.svg";
import outline_resizer from "./outline/resizer.svg";
import outline_restricted from "./outline/restricted.svg";
import outline_rhombus from "./outline/rhombus.svg";
import outline_rolemapping from "./outline/role-mapping.svg";
import outline_roundedrectangle from "./outline/rounded-rectangle.svg";
import outline_sandclock from "./outline/sand-clock.svg";
import outline_scim from "./outline/scim.svg";
import outline_scroll from "./outline/scroll.svg";
import outline_search from "./outline/search.svg";
import outline_security from "./outline/security.svg";
import outline_send from "./outline/send.svg";
import outline_sessions from "./outline/sessions.svg";
import outline_shape from "./outline/shape.svg";
import outline_share from "./outline/share.svg";
import outline_shopping_box3d50 from "./outline/shopping_box-3d-50.svg";
import outline_shopping_creditcard from "./outline/shopping_credit-card.svg";
import outline_slacknewlogo from "./outline/slack-new-logo.svg";
import outline_slack from "./outline/slack.svg";
import outline_slashedcircle from "./outline/slashed-circle.svg";
import outline_sort from "./outline/sort.svg";
import outline_sql from "./outline/sql.svg";
import outline_stop from "./outline/stop.svg";
import outline_strokelarge from "./outline/stroke-large.svg";
import outline_strokemedium from "./outline/stroke-medium.svg";
import outline_strokesmall from "./outline/stroke-small.svg";
import outline_subscription from "./outline/subscription.svg";
import outline_suggestioncardrefresh from "./outline/suggestion-card-refresh.svg";
import outline_suggestioncardremove from "./outline/suggestion-card-remove.svg";
import outline_suggestionsloading from "./outline/suggestions-loading.svg";
import outline_support from "./outline/support.svg";
import outline_tbold from "./outline/t-bold.svg";
import outline_titalic from "./outline/t-italic.svg";
import outline_tstrike from "./outline/t-strike.svg";
import outline_tunderlined from "./outline/t-underlined.svg";
import outline_t from "./outline/t.svg";
import outline_table from "./outline/table.svg";
import outline_tag from "./outline/tag.svg";
import outline_target from "./outline/target.svg";
import outline_task from "./outline/task.svg";
import outline_team from "./outline/team.svg";
import outline_tech_computermonitor from "./outline/tech_computer-monitor.svg";
import outline_tech_mobilebutton from "./outline/tech_mobile-button.svg";
import outline_textlink from "./outline/text-link.svg";
import outline_track from "./outline/track.svg";
import outline_transportation_boatfront from "./outline/transportation_boat-front.svg";
import outline_transportation_moto from "./outline/transportation_moto.svg";
import outline_transportation_plane18 from "./outline/transportation_plane-18.svg";
import outline_trashbin from "./outline/trash-bin.svg";
import outline_travel_hut from "./outline/travel_hut.svg";
import outline_travel_shark from "./outline/travel_shark.svg";
import outline_travel_world from "./outline/travel_world.svg";
import outline_twoarrowsleftsmall from "./outline/two-arrows-left-small.svg";
import outline_twoarrowsrightsmall from "./outline/two-arrows-right-small.svg";
import outline_ui1_analytics88 from "./outline/ui-1_analytics-88.svg";
import outline_ui1_calendarcheck59 from "./outline/ui-1_calendar-check-59.svg";
import outline_ui1_circledelete from "./outline/ui-1_circle-delete.svg";
import outline_ui1_dashboard30 from "./outline/ui-1_dashboard-30.svg";
import outline_ui1_database from "./outline/ui-1_database.svg";
import outline_ui1_eye17 from "./outline/ui-1_eye-17.svg";
import outline_ui1_home51 from "./outline/ui-1_home-51.svg";
import outline_ui1_send from "./outline/ui-1_send.svg";
import outline_ui1_settingsgear64 from "./outline/ui-1_settings-gear-64.svg";
import outline_ui1_simpleremove from "./outline/ui-1_simple-remove.svg";
import outline_ui2_cloud25 from "./outline/ui-2_cloud-25.svg";
import outline_ui2_favourite28 from "./outline/ui-2_favourite-28.svg";
import outline_ui2_favourite31 from "./outline/ui-2_favourite-31.svg";
import outline_ui2_lab from "./outline/ui-2_lab.svg";
import outline_ui2_like from "./outline/ui-2_like.svg";
import outline_unknown from "./outline/unknown.svg";
import outline_up from "./outline/up.svg";
import outline_updatereminder from "./outline/update-reminder.svg";
import outline_upgradeplan from "./outline/upgrade-plan.svg";
import outline_upload from "./outline/upload.svg";
import outline_user from "./outline/user.svg";
import outline_usersgroup from "./outline/users-group.svg";
import outline_users_multiple11 from "./outline/users_multiple-11.svg";
import outline_users_network from "./outline/users_network.svg";
import outline_verification from "./outline/verification.svg";
import outline_viewonly from "./outline/view-only.svg";
import outline_warn from "./outline/warn.svg";
import outline_weather_hurricane44 from "./outline/weather_hurricane-44.svg";
import outline_weather_moon from "./outline/weather_moon.svg";
import outline_whiteboards from "./outline/whiteboards.svg";
import outline_wizard from "./outline/wizard.svg";
import outline_workday from "./outline/workday.svg";
import twotone_automations from "./twotone/automations.svg";

export const fillIcons = [
  fill_alignedunder,
  fill_alignment,
  fill_alltime,
  fill_announcement,
  fill_arrowdown,
  fill_arrows1_refresh68,
  fill_arrowsdownup,
  fill_attachment,
  fill_attention,
  fill_audio,
  fill_automation,
  fill_badge,
  fill_binocular,
  fill_blocked,
  fill_business_books,
  fill_business_bulb61,
  fill_business_businesscontact86,
  fill_business_chartpie35,
  fill_business_coins,
  fill_business_factory,
  fill_business_hammer,
  fill_business_hierarchy55,
  fill_business_moneycoins,
  fill_business_strategy,
  fill_business_wallet90,
  fill_cascadingmetricalignment,
  fill_cascadingmetric,
  fill_checkin,
  fill_checkwhite,
  fill_clothes_shoewoman,
  fill_clothes_slacks13,
  fill_clothes_tiebow,
  fill_colorstarorangestroke,
  fill_comments,
  fill_contributingmetric,
  fill_conversation,
  fill_design_bookbookmark,
  fill_design_clone,
  fill_design_codeeditor,
  fill_design_code,
  fill_design_crop,
  fill_design_design,
  fill_design_mouse10,
  fill_design_paint38,
  fill_design_wand99,
  fill_design_webdesign,
  fill_design_windowcode,
  fill_design_windowdev,
  fill_design_windowparagraph,
  fill_dots,
  fill_down,
  fill_education_atom,
  fill_education_board51,
  fill_education_hat,
  fill_education_language,
  fill_ellipse,
  fill_emoticons_fist,
  fill_emoticons_like,
  fill_emoticons_monster,
  fill_emoticons_sunglasses48,
  fill_emoticons_virus,
  fill_employee,
  fill_eye,
  fill_favorite,
  fill_files_folder19,
  fill_food_coffeelong,
  fill_food_mug,
  fill_furniture_bedside,
  fill_goal,
  fill_health_brain,
  fill_health_weed,
  fill_image,
  fill_inactivetask,
  fill_insight,
  fill_insightboard,
  fill_jirabug,
  fill_jiraepic,
  fill_jiraissue,
  fill_jirastory,
  fill_jirasubtask,
  fill_jiratask,
  fill_jira,
  fill_kpi,
  fill_links,
  fill_list,
  fill_loader_refresh,
  fill_location_compass04,
  fill_location_positionmarker,
  fill_marketplace,
  fill_media1_image02,
  fill_media1_sport,
  fill_media1_touch,
  fill_media1_video67,
  fill_mention,
  fill_metric,
  fill_minus,
  fill_modelandscape,
  fill_modeportrait,
  fill_more,
  fill_nopermissions,
  fill_noreflections,
  fill_nosearchresults,
  fill_objects_bear,
  fill_objects_leaf36,
  fill_objects_planet,
  fill_objects_spaceship,
  fill_objects_support17,
  fill_pdf,
  fill_plancommercial,
  fill_planenterprise,
  fill_planessentials,
  fill_planscale,
  fill_planupgrade,
  fill_plus,
  fill_presentation,
  fill_private,
  fill_progress,
  fill_public,
  fill_quantivecirclelogo,
  fill_related,
  fill_restrictedlicense,
  fill_search,
  fill_selectuser,
  fill_session,
  fill_shopping_box3d50,
  fill_shopping_creditcard,
  fill_spreadsheet,
  fill_standardlicense,
  fill_success,
  fill_suggestions,
  fill_taskgreen,
  fill_task,
  fill_team,
  fill_tech_computermonitor,
  fill_tech_mobilebutton,
  fill_text,
  fill_thumbdown,
  fill_thumbup,
  fill_transportation_plane18,
  fill_trashbin,
  fill_travel_hut,
  fill_travel_world,
  fill_ui1_analytics88,
  fill_ui1_boldremove,
  fill_ui1_calendarcheck59,
  fill_ui1_checksimple,
  fill_ui1_dashboard30,
  fill_ui1_database,
  fill_ui1_home51,
  fill_ui1_settingsgear64,
  fill_ui1_simpleremove,
  fill_ui2_alert,
  fill_ui2_cloud25,
  fill_ui2_favourite28,
  fill_ui2_favourite31,
  fill_ui2_hourglass,
  fill_ui2_lab,
  fill_ui2_linkbroken70,
  fill_up,
  fill_updatereminder,
  fill_update,
  fill_upgrade,
  fill_upload,
  fill_users_multiple11,
  fill_users_multiple19,
  fill_video,
  fill_whiteboard,
  fill_zip,
];

export const outlineIcons = [
  outline_addfrommarketplace,
  outline_address,
  outline_alignbottom,
  outline_aligncenter,
  outline_alignleft,
  outline_alignmiddle,
  outline_alignright,
  outline_aligntop,
  outline_alignmentview,
  outline_announcements,
  outline_apps,
  outline_archive,
  outline_arrowbig,
  outline_arrowdownsmall,
  outline_arrowrightsmall,
  outline_arrowupsmall,
  outline_arrows1_refresh68,
  outline_arrows1_tailleft,
  outline_arrows1_tailright,
  outline_arrowsin,
  outline_arrowsout,
  outline_artificialintelligenceanimated,
  outline_artificialintelligence,
  outline_ask,
  outline_attachment,
  outline_attention,
  outline_automation,
  outline_award,
  outline_back,
  outline_bad,
  outline_badgeaibetav2,
  outline_billinghistory,
  outline_binocular,
  outline_blocked,
  outline_book,
  outline_branding,
  outline_business_award48,
  outline_business_books,
  outline_business_bulb61,
  outline_business_businesscontact86,
  outline_business_businesscontact89,
  outline_business_businessman03,
  outline_business_chartpie35,
  outline_business_coins,
  outline_business_factory,
  outline_business_hammer,
  outline_business_hierarchy55,
  outline_business_moneycoins,
  outline_business_strategy,
  outline_business_wallet90,
  outline_calendar,
  outline_casttv,
  outline_caution,
  outline_chart,
  outline_chat,
  outline_checkinnotifications,
  outline_checkin,
  outline_checksmall,
  outline_check,
  outline_chevrondoubleleftbig,
  outline_chevrondoublerightbig,
  outline_chevrondownbig,
  outline_chevrondownsmall,
  outline_chevronleftbig,
  outline_chevronleftdouble,
  outline_chevronleftsmall,
  outline_chevronrightbig,
  outline_chevronrightdoublebig,
  outline_chevronrightdouble,
  outline_chevronrightsmall,
  outline_chevronupbig,
  outline_chevronupsmall,
  outline_circle1,
  outline_circle,
  outline_clipboard,
  outline_clock,
  outline_closebig,
  outline_closemedium,
  outline_closemenu,
  outline_clothes_shoewoman,
  outline_clothes_slacks13,
  outline_clothes_tiebow,
  outline_clothes_vestsport,
  outline_collapsenav,
  outline_comments,
  outline_consulting,
  outline_createnew,
  outline_creditcard,
  outline_customfield,
  outline_design_bookbookmark,
  outline_design_clone,
  outline_design_codeeditor,
  outline_design_code,
  outline_design_crop,
  outline_design_design,
  outline_design_mouse10,
  outline_design_paint38,
  outline_design_wand99,
  outline_design_webdesign,
  outline_design_windowcode,
  outline_design_windowdev,
  outline_design_windowparagraph,
  outline_dislike,
  outline_done,
  outline_down,
  outline_download,
  outline_dragdrop,
  outline_dragicon,
  outline_edit,
  outline_education_atom,
  outline_education_board51,
  outline_education_hat,
  outline_education_language,
  outline_email,
  outline_emoticons_angry44,
  outline_emoticons_cake,
  outline_emoticons_fist,
  outline_emoticons_like,
  outline_emoticons_monster,
  outline_emoticons_nerd22,
  outline_emoticons_sunglasses48,
  outline_emoticons_virus,
  outline_exclamationmark,
  outline_expand,
  outline_exportexcel,
  outline_export,
  outline_externallink,
  outline_failed,
  outline_favorite,
  outline_files_folder19,
  outline_filterview,
  outline_filter,
  outline_fittoscreen,
  outline_food_broccoli,
  outline_food_chefhat,
  outline_food_chili,
  outline_food_coffeelong,
  outline_food_crab,
  outline_food_moka,
  outline_food_muffin,
  outline_food_mug,
  outline_fullsize,
  outline_furniture_bedside,
  outline_gif,
  outline_good,
  outline_gridview,
  outline_halfsize,
  outline_hand,
  outline_health_brain,
  outline_health_weed,
  outline_help,
  outline_hidden,
  outline_home,
  outline_idea,
  outline_image,
  outline_infobig,
  outline_info,
  outline_inline,
  outline_insightboard,
  outline_insights,
  outline_install,
  outline_integrations,
  outline_jira,
  outline_kanban,
  outline_key,
  outline_kpi,
  outline_kr,
  outline_lessisbetter,
  outline_license,
  outline_like,
  outline_link,
  outline_listbullet,
  outline_listnumbers,
  outline_listview,
  outline_livedemo,
  outline_loadingcircular,
  outline_location_compass04,
  outline_location_explore,
  outline_location_flagdiagonal33,
  outline_location_positionmarker,
  outline_logo,
  outline_makecopy,
  outline_manage,
  outline_map,
  outline_media1_audio92,
  outline_media1_flash24,
  outline_media1_image02,
  outline_media1_lens31,
  outline_media1_sport,
  outline_media1_touch,
  outline_media1_video67,
  outline_media2_guitar,
  outline_mentions,
  outline_menuhorizontal,
  outline_menuvertical,
  outline_minus,
  outline_moreisbetter,
  outline_moveto,
  outline_move,
  outline_multiselect,
  outline_negativedelete,
  outline_neutralwarn,
  outline_neutral,
  outline_newlist,
  outline_newokr,
  outline_next,
  outline_nocheckins,
  outline_notrestricted,
  outline_note,
  outline_notificationsoff,
  outline_notifications,
  outline_objective,
  outline_objects_alien29,
  outline_objects_alien33,
  outline_objects_baby,
  outline_objects_bear,
  outline_objects_binocular,
  outline_objects_diamond,
  outline_objects_leaf36,
  outline_objects_leaf38,
  outline_objects_planet,
  outline_objects_spaceship,
  outline_objects_support17,
  outline_openmenu,
  outline_organization,
  outline_parallelogram,
  outline_parentchildview,
  outline_parentview,
  outline_pause,
  outline_pdf,
  outline_performance,
  outline_pie,
  outline_pin,
  outline_platformintelligencedefault,
  outline_play,
  outline_pluscircle,
  outline_plus,
  outline_pointer,
  outline_process,
  outline_public,
  outline_quantivepluscaution,
  outline_reaction,
  outline_recenter,
  outline_rectangle,
  outline_refresh,
  outline_rename,
  outline_resizer,
  outline_restricted,
  outline_rhombus,
  outline_rolemapping,
  outline_roundedrectangle,
  outline_sandclock,
  outline_scim,
  outline_scroll,
  outline_search,
  outline_security,
  outline_send,
  outline_sessions,
  outline_shape,
  outline_share,
  outline_shopping_box3d50,
  outline_shopping_creditcard,
  outline_slacknewlogo,
  outline_slack,
  outline_slashedcircle,
  outline_sort,
  outline_sql,
  outline_stop,
  outline_strokelarge,
  outline_strokemedium,
  outline_strokesmall,
  outline_subscription,
  outline_suggestioncardrefresh,
  outline_suggestioncardremove,
  outline_suggestionsloading,
  outline_support,
  outline_tbold,
  outline_titalic,
  outline_tstrike,
  outline_tunderlined,
  outline_t,
  outline_table,
  outline_tag,
  outline_target,
  outline_task,
  outline_team,
  outline_tech_computermonitor,
  outline_tech_mobilebutton,
  outline_textlink,
  outline_track,
  outline_transportation_boatfront,
  outline_transportation_moto,
  outline_transportation_plane18,
  outline_trashbin,
  outline_travel_hut,
  outline_travel_shark,
  outline_travel_world,
  outline_twoarrowsleftsmall,
  outline_twoarrowsrightsmall,
  outline_ui1_analytics88,
  outline_ui1_calendarcheck59,
  outline_ui1_circledelete,
  outline_ui1_dashboard30,
  outline_ui1_database,
  outline_ui1_eye17,
  outline_ui1_home51,
  outline_ui1_send,
  outline_ui1_settingsgear64,
  outline_ui1_simpleremove,
  outline_ui2_cloud25,
  outline_ui2_favourite28,
  outline_ui2_favourite31,
  outline_ui2_lab,
  outline_ui2_like,
  outline_unknown,
  outline_up,
  outline_updatereminder,
  outline_upgradeplan,
  outline_upload,
  outline_user,
  outline_usersgroup,
  outline_users_multiple11,
  outline_users_network,
  outline_verification,
  outline_viewonly,
  outline_warn,
  outline_weather_hurricane44,
  outline_weather_moon,
  outline_whiteboards,
  outline_wizard,
  outline_workday,
];

export const twotoneIcons = [twotone_automations];

export const icons = [...fillIcons, ...outlineIcons, ...twotoneIcons];
